/**
 * @file HidCommandCodec.ts
 * @description HID EEPROM 读写命令封包工具。
 * 它只负责协议字节布局，不负责发送、不负责业务解析。
 */

import type { CommonAddress, ProtocolConfig } from '../../../../types/protocol'

const ADDRESS_LENGTH = 4

/**
 * 创建读命令 payload。
 */
export function encodeHidReadPayload(
  config: ProtocolConfig,
  connectionType: number,
  address: CommonAddress,
  length: number,
): Uint8Array {
  return new Uint8Array([connectionType, config.readCmd[0], length, ...address])
}

/**
 * 创建写命令 payload。
 */
export function encodeHidWritePayload(
  config: ProtocolConfig,
  connectionType: number,
  address: CommonAddress,
  data: number[],
): Uint8Array {
  let finalAddress = [...address]
  if (address.length < ADDRESS_LENGTH) {
    finalAddress = [...address, ...new Array(ADDRESS_LENGTH - address.length).fill(0)]
  }

  return new Uint8Array([connectionType, config.writeCmd[0], data.length, ...finalAddress, ...data])
}
